module.exports = __webpack_public_path__ + "img/emptyimage.b08fc121.jpg";